import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MenuItemSC } from './menu-item.styled';

type TMenuItemProps = {
  name: string;
  icon?: React.ReactNode;
  onClick(): void;
  translateName?: boolean;
};

const MenuItem: React.FC<TMenuItemProps> = ({
  icon,
  name,
  translateName = true,
  onClick,
}: TMenuItemProps) => {
  return (
    <MenuItemSC onClick={onClick}>
      {icon && <div className="mi-icon">{icon}</div>}
      <span className="mi-name">{translateName ? <FormattedMessage id={name} /> : name}</span>
      <img
        className="mi-chevron"
        src={require('../../../../assets/svg/icon-chevron-left.svg').default}
        alt=""
      />
    </MenuItemSC>
  );
};

export default MenuItem;
